var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22278 13.3422L0.951604 13.3422L0.951606 9.66047L6.22278 9.66047H7.02346L6.45729 9.12075L2.72477 5.56253L5.45876 2.95622L9.19128 6.51444L9.75745 7.05416L9.75745 6.29087L9.75745 1.26587H13.6195L13.6195 6.29088V7.05416L14.1857 6.51444L17.9182 2.95622L20.6522 5.56253L16.9197 9.12075L16.3535 9.66047H17.1542L22.4253 9.66047L22.4253 13.3422L17.1542 13.3422H16.3535L16.9197 13.8819L20.6522 17.4401L17.9182 20.0464L14.1857 16.4882L13.6195 15.9485L13.6195 16.7118L13.6195 21.7368L9.75745 21.7368V16.7118V15.9485L9.19128 16.4882L5.45876 20.0464L2.72477 17.4401L6.4573 13.8819L7.02346 13.3422H6.22278Z",
    fill: "#646464",
    stroke: "#646464",
    strokeWidth: 0.648002
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.70264e0538b304846f701ee45601437b.svg";
export { ForwardRef as ReactComponent };